module.exports = __webpack_public_path__ + "media/per/bghead-004406ca.png";